import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.Scheduler', {
    day: 'Day',
    month: 'Month',
    year: 'Year',
    prediction: 'Next execution dates',
    time: 'Execution time',
    endDate: 'End date (optional)',
    save: 'Save',
    title: 'Scheduler',
    select: 'Select...',
    januaryShort: 'Jan',
    january: 'January',
    februaryShort: 'Feb',
    february: 'February',
    marchShort: 'Mar',
    march: 'March',
    aprilShort: 'Apr',
    april: 'April',
    mayShort: 'May',
    may: 'May',
    juneShort: 'Jun',
    june: 'June',
    julyShort: 'Jul',
    july: 'July',
    augustShort: 'Aug',
    august: 'August',
    septemberShort: 'Sep',
    september: 'September',
    octoberShort: 'Oct',
    october: 'October',
    novemberShort: 'Nov',
    november: 'November',
    decemberShort: 'Dec',
    december: 'December',
});
